/**
 * Integration enum definitions.
 * This file is separate from integration-triggers.ts to avoid circular dependencies
 * with schema files that need to reference Integration enum values.
 */
export enum Integration {
  JUDGEME = "judgeme",
  LOYALTY_LION = "loyalty_lion",
  RECHARGE = "recharge",
  SMILE = "smile",
  YOTPO = "yotpo",
}
